module.exports = __webpack_public_path__ + "img/inteligenciaejecutiva1.dac0c48d.png";